<script setup>
import { onMounted, useTemplateRef, computed } from 'vue';
import VuePlyr from 'vue-plyr'
import Icon from './Icon.vue';

const props = defineProps({
    video: Object,
});

const plyr = useTemplateRef('plyr');

onMounted(() => {
    // No vue support for events, have to use ref + regular event listener :(
    plyr.value.player.on('exitfullscreen', () => {
        plyr.value.player.pause();
    })
    plyr.value.player.on('play', () => {
        plyr.value.player.fullscreen.enter();
    })
})


const videoType = computed(() => {
    // Mov causes problems on certain browsers if not specified as mp4
    if (props.video.mimetype === 'mov'){
        return 'video/mp4';
    }

    return `video/${props.video.mimetype}`;
})

</script>

<template>
    <div class="relative isolate group overflow-hidden cursor-pointer">

        <div class="pointer-events-none absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 bg-white text-gray-800 size-16 xl:size-20 rounded-full grid place-items-center z-20 group-hover:scale-110 transition-transform duration-300">
            <Icon class="size-5 xl:size-7 ml-0.5" name="video-play" />
        </div>

        <img :src="props.video.poster" class="absolute left-0 top-0 size-full object-cover z-10 pointer-events-none group-hover:scale-105 transition-transform duration-500">

        <vue-plyr
            class="absolute left-0 top-0 size-full"
            :options="{
                fullscreen: {
                    enabled: true
                },
                clickToPlay: true,
                iconUrl: '/bundles/salestool/assets/images/plyr.svg',
            }"
            ref="plyr"
        >
            <video
                controls
                crossorigin
                playsinline
            >
                <source
                    :src="props.video.src"
                    :type="videoType"
                />
            </video>
        </vue-plyr>
    </div>
</template>
    